import service from './axios';

// 获取消费渠道列表
export const fetchConsumptionChannelList = (params) => {
  return service({
    method: 'get',
    url: '/manage/consumption-channels',
    params
  });
};

// 获取消费渠道详情
export const fetchConsumptionChannelDetail = (id) => {
  return service({
    method: 'get',
    url: `/manage/consumption-channels/${id}`,
  });
};

// 新增消费渠道
export const addConsumptionChannel = (data) => {
  return service({
    method: 'post',
    url: '/manage/consumption-channels',
    data
  });
};

// 更新消费渠道
export const updateConsumptionChannel = (id, data) => {
  return service({
    method: 'put',
    url: `/manage/consumption-channels/${id}`,
    data
  });
};

// 删除消费渠道
export const deleteConsumptionChannel = (id) => {
  return service({
    method: 'delete',
    url: `/manage/consumption-channels/${id}`,
  });
};

// 前端获取渠道列表
export const getFrontendConsumptionChannels = () => {
  return service({
    method: 'get',
    url: '/front/consumption-channels'
  });
};
